import {
    getAdvanced,
    getBackgroundImages,
    getVerticalAlignment,
    readInlineStyleValue
} from '../../utils'

const configAggregator = (node) => {
    return {
        tabName: node.getAttribute('data-tab-name'),
        minHeight: readInlineStyleValue(node.style.minHeight),
        ...getVerticalAlignment(node),
        backgroundColor: readInlineStyleValue(node.style.backgroundColor),
        ...getBackgroundImages(node),
        ...getAdvanced(node)
    }
}

export default configAggregator
